module.exports = __webpack_public_path__ + "0b02f5978135b7bcbad3dc24e1a216fd.webp";